module.exports = __webpack_public_path__ + "static/media/pass_icon.cd322182.svg";